<template>
    <div>
        <div class="modal fade" id="myAccountJm" tabindex="-1" aria-labelledby="myAccountJmLabel" aria-hidden="true"
            data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                    <div class="modal-header2 p-0" style="">
                        <h6 class="modal-title" id="exampleModalLabel">{{ translate('balance_history')}}
                            <button id="closemyAccountJm" :style="skin.my_account.close_btn"
                                style="background:transparent;float: right;color:white" type="button" class="btn-close"
                                data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                        </h6>
                    </div>
                    <div class="modal-body p-4">
                        <div v-if="loading_report" style="width:100%" class="text-center p-2">
                            <div class="spinner-border" style="color:beige" role="status">
                                <span class="visually-hidden">{{ translate('loading') }}</span>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table" style="color:white;font-size: 15px;">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ translate('date') }}</th>
                                        <th scope="col">{{ translate('supplier') }}</th>
                                        <th scope="col">{{ translate('detail') }}</th>
                                        <th scope="col">{{ translate('amount') }}</th>
                                        <th scope="col">{{ translate('balance2') }}</th>
                                        <th scope="col">{{ translate('claim') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in paginarArray(report, registers_per_page)[actual_page - 1]" :key="index">
                                        <td>{{ formatearFecha(item.fecha) }}</td>
                                        <td>{{ item.proveedor }}</td>
                                        <td>{{ item.operacion }}</td>
                                        <td>{{ parseNumbers(item.valor) }}</td>
                                        <td>{{ parseNumbers(item.nuevo_capital) }}</td>
                                        <td><span><i class="fa-regular fa-comment-dots"></i></span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <pagination class="float-end" :options="paginationConf" v-model="actual_page" :records="records" :per-page="registers_per_page" @paginate="paginate"/>
                        </div><br><br><br>
                        <div class="text-center">
                            <button class="btn" style="background-color: #292d3d;color:white" data-bs-dismiss="modal" aria-label="Close">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import Pagination from 'vue-pagination-2';
import MyPagination from './Pagination.vue'
import axios from 'axios';
export default {
    name: "myAccountJm",
    props: ['skin', 'translation', 'language'],
    components:{Pagination},
    data() {
        return {
            report:[],
            actual_page:1,
            records:0,
            registers_per_page:10,
            paginationConf:{
                texts:{count:''},
                template:MyPagination
            },
            loading_report:false
        }
    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
    },
    methods: {
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        paginate(page){
            this.actual_page = page;
        },
        paginarArray(array, elementosPorPagina) {
            const paginas = [];
            let paginaActual = [];

            for (let i = 0; i < array.length; i++) {
                if (paginaActual.length === elementosPorPagina) {
                    paginas.push(paginaActual);
                    paginaActual = [];
                }
                paginaActual.push(array[i]);
            }

            if (paginaActual.length > 0) {
                paginas.push(paginaActual);
            }
            this.records = array.length;
            this.pages = paginas;
            return paginas;
        },
        async getData() {
            this.loading_report=true;
            let data = await axios.post(this.apiUrlnew +"historial_jugador", {
                "username": this.user.user_data.data.user_name,
                "startDate": "2020-01-01 00:00:00",
                "endDate": "2030-12-31 23:59:59",
                "token":this.user.token,
                "timezone": "-05:00",
                "site": this.site
            })
            this.report = data.data
            this.loading_report=false;
        },
        parseNumbers(number){
            return new Intl.NumberFormat("de-DE",{minimumFractionDigits:2, maximumFractionDigits: 2}).format(number)
        },  
        formatearFecha(fechaString) {
            const fecha = new Date(fechaString);
            const anio = fecha.getFullYear();
            const mes = this.agregarCeroDelante(fecha.getMonth() + 1);
            const dia = this.agregarCeroDelante(fecha.getDate());
            const Hora = this.agregarCeroDelante(fecha.getHours());
            const Minutos = this.agregarCeroDelante(fecha.getMinutes());
            const Segundos = this.agregarCeroDelante(fecha.getSeconds());
            return `${anio}/${mes}/${dia} ${Hora}:${Minutos}:${Segundos}`;
        },
        agregarCeroDelante(numero) {
            return numero < 10 ? '0' + numero : numero;
        },
    },
    mounted() {
        this.$root.$on('getMovementsHistory', () => {
            this.getData(); 
        });
    }
}
</script>
  
<style scoped>
.modal-header2 {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: -1.25rem !important;
    margin-bottom: 0 !important;
    height: 60px;
    padding: 1rem !important;
    color: #fff;
    border-bottom: none;
    background: linear-gradient(40deg, #292d3d, #03040d) !important
}
</style>